import * as React from 'react';
import { connect } from 'react-redux';
import { Actions as RouterActions } from 'router';
import { Selectors as Router } from 'router';
import { Selectors } from 'sections/campaigns/state/splitTests';
import { State } from 'store';
import PageWrapper from '../components/PageWrapper';
import Header from './components/header';
import Table from './components/table';
import { Box, Button, Group, Header as UCLHeader, NotificationVariation } from '@salecycle/ui-component-library';
import { Actions as NotificationBarActions } from 'core/ui/notificationBar';
import { useTranslation } from 'react-i18next';

interface StateProps {
  refreshing: boolean;
  siteId?: string;
}
interface DispatchProps {
  push?: (url: string) => void;
  showNotification?: (variation: NotificationVariation, detail: string) => void;
}

export type Props = StateProps & DispatchProps;

export const SplitTests: React.FC<Props> = (props: Props) => {
  const { t } = useTranslation(['common', 'campaigns']);
  const newSplitTest = () => {
    props.push(`/sites/${props.siteId}/campaigns/split_tests/create/settings`);
  };

  const content = props.refreshing ? undefined : <Table />;
  return (
    <PageWrapper header={<Header />}>
      <Box stackItems={true}>
        <UCLHeader heading={t('campaigns:splitTests')}>
          <Group>
            <Button variation="primary" onClick={newSplitTest}>
              {t('campaigns:newSplitTest')}
            </Button>
          </Group>
        </UCLHeader>
        {content}
      </Box>
    </PageWrapper>
  );
};

const mapState = (state: State): StateProps => ({
  refreshing: Selectors.isRefreshing(state),
  siteId: Router.getSiteId(state),
});

const actionCreators: DispatchProps = {
  push: RouterActions.push,
  showNotification: NotificationBarActions.customNotification,
};

export default connect(mapState, actionCreators)(SplitTests);
